import { PageHeader } from '@celltrak/ui-components';

const TaskHeader = () => (
  <header>
    <PageHeader title="Task Codes" />
  </header>
);

export default TaskHeader;
